import { useDispatch } from 'react-redux';
import { EmptyState, Surface } from '@vst/beam';
import { CheckMark } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { SESSION_STORAGE_VARIABLES, sessionStorageManager } from '@app/services/storageManager';
import { StackLink } from '@app/router/constants';
import { Container } from '@app/components/Container';
import { useNavigate, useScreenResolution } from '@app/hooks';
import { scrollToTop } from '@app/redux/utils';

import styles from './styles.module.scss';

export const OrderSuccess = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ShopAddons');
  const { goBack, replace } = useNavigate();

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  return (
    <Container>
      <Surface className={styles['container']} data-cy="order-confirmation-success" radius="16px">
        <EmptyState
          py={'40px'}
          px={isMobile ? '24px' : '40px'}
          icon={CheckMark}
          title={t('success.title')}
          description={t('success.description')}
          actions={{
            primary: {
              label: t('success.primaryLabel'),
              onClick: () => {
                goBack();
                dispatch(scrollToTop());
              },
              variant: 'primary',
            },
            secondary: {
              label: t('success.secondaryLabel'),
              onClick: () => {
                sessionStorageManager.setItem(SESSION_STORAGE_VARIABLES.SHOW_PLAN_TAB, true);
                replace(`/${StackLink.Profile}`);
              },
              variant: 'secondary',
            },
          }}
          actionsLayout={'vertical'}
        />
      </Surface>
    </Container>
  );
};
